import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import RenameIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import ActionsMenuButton from "@entrilia/shared/components/ActionsMenuButton";
import type { FundraisingInfo } from "../../../../api/types/fundraisingTypes";
import { useFundraisingsPageContext } from "./FundraisingsPageContext";
import { getAvailableStatusTransitions } from "./fundraisingStatusHelper";

export const ActionsCell = ({ row }: { row: FundraisingInfo }) => {
  const { hasEditPermissions, onRename, onStatusChange, onDelete } = useFundraisingsPageContext();

  if (!hasEditPermissions) {
    return null;
  }

  return (
    <ActionsMenuButton
      items={[
        {
          label: "Rename",
          icon: <RenameIcon />,
          onClick: () => onRename(row.id, row.name, row.etag),
        },
        ...getAvailableStatusTransitions(row.status).map((transition) => ({
          label: transition.label,
          icon: <transition.Icon color="secondary" />,
          onClick: () => onStatusChange(row, transition),
          disabled: (transition.to === "Preview" || transition.to === "Live") && !row.isReadyForPublishing,
        })),
        {
          label: "Delete",
          icon: <DeleteIcon color="error" />,
          onClick: () => onDelete(row.id, row.name),
          disabled: row.status === "Live",
        },
      ]}
    />
  );
};
